import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { dcbNamesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import * as API from '../../api'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import ChipInput from 'material-ui-chip-input'
import { readOnly } from '../../utils/permissions'
import { formatContentSelectValue, filterOptionsFunction } from '../../utils'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../components/SelectWrapped'
import Chip from '@material-ui/core/Chip'
import { newFormNameDcb } from '../../actions/namesDcb'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  },
  formSelect: {
    marginTop: '23px',
    paddingBottom: '12px'
  }
})

class EditModal extends Component {
  handleSave = nameDcb => {
    const { onClose, addNameDcb, editNameDcb, changeMessage } = this.props
    if (nameDcb._id) {
      editNameDcb(nameDcb).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addNameDcb(nameDcb).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, nameDcb) => {
    e.preventDefault()
    const { setNameDcbFormTouched } = this.props

    if ((this.props.nameDcbFormErrors || {}).valid) {
      if (((nameDcb.classificacoesAtc || [])[0] || {}).value) {
        nameDcb.classificacoesAtc = (nameDcb.classificacoesAtc || []).map(record => record.value)
      }
      if (!nameDcb.conteudos) {
        nameDcb.conteudos = []
      }
      this.handleSave(nameDcb)
    } else {
      setNameDcbFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  handleAddSinonimo = sinonimo => {
    const { nameDcb = '' } = this.props
    let sinonimos = nameDcb.sinonimos || []

    const duplicated = sinonimos.find(
      item => item.trim().toLowerCase() === sinonimo.trim().toLowerCase()
    )

    sinonimos = duplicated ? sinonimos : [...sinonimos, sinonimo]

    this.props.handleChangeNameDcb({ ...nameDcb, sinonimos: sinonimos || [] })
  }

  handleDeleteSinonimo = sinonimo => {
    const { nameDcb = '' } = this.props
    let sinonimos = nameDcb.sinonimos || []

    sinonimos = sinonimos.filter(item => item !== sinonimo)

    this.props.handleChangeNameDcb({ ...nameDcb, sinonimos: sinonimos || [] })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      nameDcb,
      handleChangeNameDcb,
      loadingNameDcb,
      nameDcbFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('nomesDcb', token)

    return (
      <div>
        <Dialog
          modalId={nameDcb._id ? 'nomes-dcb-editar' : 'nomes-dcb-novo'}
          modalParams={{ registro: nameDcb._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingNameDcb ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(nameDcb._id ? 'nomes-dcb-editar' : 'nomes-dcb-novo') + '-title'}>
                {isReadOnly ? (
                  'nomesDcb'
                ) : (
                  <Fragment>{nameDcb._id ? 'Editar nome DCB' : 'Cadastrar nome DCB'}</Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'nameDcb-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, nameDcb)
                  }}
                >
                  <FormControl
                    error={!((nameDcbFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeNameDcb({ ...nameDcb, nome: e.target.value })
                      }}
                      value={nameDcb.nome}
                      autoFocus
                      id="field-nome"
                    />

                    {!((nameDcbFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['numero_dcb'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-numero_dcb">Número DCB</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="number"
                      onChange={e => {
                        clearErrors()
                        handleChangeNameDcb({ ...nameDcb, numero_dcb: e.target.value })
                      }}
                      value={nameDcb.numero_dcb}
                      id="field-numero_dcb"
                    />

                    {!((nameDcbFormErrors.fields || {})['numero_dcb'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['numero_dcb'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['sinonimos'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <ChipInput
                      disabled={isReadOnly}
                      id="field-sinonimos"
                      value={nameDcb.sinonimos ? nameDcb.sinonimos : []}
                      label={'Sinônimos'}
                      inputProps={{
                        form: 'non-form'
                      }}
                      onAdd={this.handleAddSinonimo}
                      onDelete={this.handleDeleteSinonimo}
                      chipRenderer={(
                        {
                          value,
                          text,
                          isFocused,
                          isDisabled,
                          handleClick,
                          handleDelete,
                          className
                        },
                        key
                      ) => (
                        <Chip
                          key={key}
                          className={className}
                          style={{
                            pointerEvents: isDisabled ? 'none' : undefined,
                            backgroundColor: isFocused ? 'black' : undefined
                          }}
                          onClick={handleClick}
                          onDelete={isDisabled ? null : handleDelete}
                          label={text}
                        />
                      )}
                    />
                    {!((nameDcbFormErrors.fields || {})['sinonimos'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['sinonimos'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['numero_cas'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-numero_cas">Numero CAS</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeNameDcb({ ...nameDcb, numero_cas: e.target.value })
                      }}
                      value={nameDcb.numero_cas}
                      id="field-numero_cas"
                    />

                    {!((nameDcbFormErrors.fields || {})['numero_cas'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['numero_cas'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['receita_tipo'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-receita_tipo">Tipo de Receita</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      type="text"
                      inputProps={{ maxLength: 30 }}
                      onChange={e => {
                        clearErrors()
                        handleChangeNameDcb({ ...nameDcb, receita_tipo: e.target.value })
                      }}
                      value={nameDcb.receita_tipo || ''}
                      id="field-receita_tipo"
                    />

                    {!((nameDcbFormErrors.fields || {})['receita_tipo'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['receita_tipo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['classificacoes_atc'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeNameDcb({ ...nameDcb, classificacoesAtc: obj })
                      }}
                      error={
                        !((nameDcbFormErrors.fields || {})['classificacoes_atc'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValue(nameDcb.classificacoesAtc || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Classificações ATC"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.atcClassifications.getSelectAtcClassifications,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((nameDcbFormErrors.fields || {})['classificacoes_atc'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((nameDcbFormErrors.fields || {})['classificacoes_atc'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((nameDcbFormErrors.fields || {})['conteudos'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeNameDcb({ ...nameDcb, conteudos: obj })
                      }}
                      error={
                        !((nameDcbFormErrors.fields || {})['conteudos'] || {}).valid && formTouched
                      }
                      value={formatContentSelectValue(nameDcb.conteudos || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Ficha de Medicamentos"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.namesDcb.getSelectMedicationsSheets,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((nameDcbFormErrors.fields || {})['conteudos'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((nameDcbFormErrors.fields || {})['conteudos'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'nameDcb-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    nameDcb: state.namesDcb.nameDcb,
    loadingNameDcb: state.namesDcb.loadingNameDcb,
    nameDcbFormErrors: state.namesDcb.nameDcbFormErrors,
    formTouched: state.namesDcb.nameDcbFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(dcbNamesActions.openModal())
    },
    closeModal: () => {
      dispatch(dcbNamesActions.closeModal())
    },
    handleChangeNameDcb: nameDcb => {
      dispatch(dcbNamesActions.handleChangeNameDcb(nameDcb))
    },
    addNameDcb: nameDcb => {
      return dispatch(dcbNamesActions.addNameDcb(nameDcb))
    },
    editNameDcb: nameDcb => {
      return dispatch(dcbNamesActions.editNameDcb(nameDcb))
    },
    setNameDcbFormTouched: () => {
      dispatch(dcbNamesActions.setNameDcbFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/DcbNames/EditModal.js